<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary">Asset Type</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item"><a href="javascript:void(0);" @click="backParent">Asset Type</a></li>
                <li class="breadcrumb-item active">
                  <span v-if="asset.id === null">New</span>
                  <span v-else>{{ asset.name }}</span>
                </li>
              </ol>
              <button type="button" @click="updateAsset" class="btn btn-sm btn-soft-primary pull-left" v-show="asset.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
              <button type="button" @click="createAsset" class="btn btn-sm btn-soft-primary pull-left" v-show="asset.id == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 150px">
          <div class="col-md-12">
              <div class="card">
                  <div class="card-header">
                      <h5>Asset Type</h5>
                  </div>
                  <div class="card-body">
                      <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                          <ul v-for="(a, index) in alert" :key="index">
                              <li v-html="a"></li>
                          </ul>
                      </div>
                      <div class="row">
                          <div class="col-md-6">
                              <dl class="row dl-custom font-12">
                                  <dt class="col-md-4">Name</dt>
                                  <dd class="col-md-8">
                                      <input type="text" class="form-control form-control-lite" v-model="asset.name"/>
                                  </dd>
                                  <dt class="col-md-4">Account Asset</dt>
                                  <dd class="col-md-8">
                                    <v-select class="vsc-custom" :options="accountSelect" :reduce="account => account.meta.code" label="account" v-model="asset.account_asset"/>
                                  </dd>
                                  <dt class="col-md-4">Account Akumulasi</dt>
                                  <dd class="col-md-8">
                                    <v-select class="vsc-custom" :options="accountSelect" :reduce="account => account.meta.code" label="account" v-model="asset.account_akumulasi"/>
                                  </dd>
                                  <dt class="col-md-4">Account Biaya Akumulasi</dt>
                                  <dd class="col-md-8">
                                    <v-select class="vsc-custom" :options="accountSelect" :reduce="account => account.meta.code" label="account" v-model="asset.account_biaya_akumulasi"/>
                                  </dd>
                                  <dt class="col-md-4">Company</dt>
                                  <dd class="col-md-8">
                                    <select v-model="asset.company_no" class="form-control">
                                      <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                                    </select>
                                  </dd>
                              </dl>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { assetUrl, getHeader } from '../../config'

export default {
  name: 'AssetTypeForm',
  props: ['asset'],
  components: {
    Loading
  },
  data () {
    return {
      alert: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  computed: {
    ...mapState({
      accountList: state => state.accounts.accountList,
      authUser: state => state.users.authUser,
      companyList: state => state.companies.companyList
    }),
    accountSelect () {
      var loop = []
      var array = this.accountList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          account: array[i].account_code + ' - ' + array[i].account_name,
          meta: {
            code: array[i].account_code
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    backParent: function () {
      this.alert = []
      this.$emit('backClicked')
    },
    async validate () {
      console.log(this.asset)
      if (this.asset.account_asset == null) {
        this.alert.push('Account Asset cannot be null')
      }
      if (this.asset.name == null) {
        this.alert.push('Name cannot be null')
      }
    },
    async createAsset () {
      this.validate()
      if (this.alert.length > 0) {
        this.$swal('Error', 'Data belum valid, cek terlebih dahulu')
        return false
      }
      await axios.post(assetUrl + '/type', this.asset, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async updateAsset () {
      this.validate()
      if (this.alert.length > 0) {
        this.$swal('Error', 'Data belum valid, cek terlebih dahulu')
        return false
      }
      await axios.put(assetUrl + '/type/' + this.asset.id, this.asset, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
